import request from 'sb-request'
import { reducers } from 'redux/core'


const fetchRecommendations = (productId) => new Promise((resolve) => {
  let requestStartMoment
  let requestCompleteMoment

  reducers.view.fragranceFinderPage.setFetching(true)

  request.get(`rest/recommendations/fragrantica/item/${productId}?perfumesOnly=true`, {
    onStart: () => {
      requestStartMoment = new Date()
    },
    onComplete: () => {
      requestCompleteMoment = new Date()
    },
  })
    .then(
      ({ items }) => {
        const requestDuration = requestCompleteMoment - requestStartMoment
        // Note: Loading should take around 3 sec (we do it intentionally to show that the algorithm is working)
        let delay = requestDuration < 3000 ? 3000 - requestDuration : 0

        const limitedItems = items.slice(0, 4)

        setTimeout(() => {
          reducers.view.fragranceFinderPage.setRecommendations(limitedItems)
          resolve(items)
        }, delay)
      },
      () => reducers.view.fragranceFinderPage.setFetching(false)
    )
})

const resetRecommendations = () => {
  reducers.view.fragranceFinderPage.setRecommendations([])
}

const fetchSearchOptions = (query) =>
  request.get('rest/engine/fr_search', {
    query: {
      query: String(query),
    },
    modifyResult: ({ suggestions }) => (
      suggestions.map(({ name, data, ...rest }) => ({
        title: name,
        id: data,
        ...rest,
      }))
    ),
  })

export default {
  fetchRecommendations,
  resetRecommendations,
  fetchSearchOptions,
}
